var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"hint":_vm.storeAddress,"items":_vm.stores,"item-text":"storeName","item-value":"id","label":"Store","persistent-hint":"","single-line":"","menu-props":{ bottom: true, offsetY: true },"dense":""},model:{value:(_vm.storeId),callback:function ($$v) {_vm.storeId=$$v},expression:"storeId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }